module.exports = __webpack_public_path__ + "img/main_banner_image.1e34ac13.png";